import script from "./dependent-coverage-assignment.vue?vue&type=script&setup=true&lang=js"
export * from "./dependent-coverage-assignment.vue?vue&type=script&setup=true&lang=js"

import "./dependent-coverage-assignment.vue?vue&type=style&index=0&id=f38d7f6c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f38d7f6c"]])

export default __exports__